import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import styled, { css } from 'styled-components';
import { alpha } from '@mui/system/colorManipulator';
import { AI_COLORS } from 'app/modules/ai/constants';

interface Props extends Omit<U21ChipProps, 'ref' | 'as' | 'color'> {}

export const AIChip = (props: Props) => {
  return <StyledU21Chip {...props} color="primary" />;
};

const StyledU21Chip = styled(U21Chip)`
  ${css`
    color: ${AI_COLORS.main};
    background: ${alpha(AI_COLORS.main, 0.08)};
    box-shadow: none;

    // fall back to default styles if disabled
    :not(.Mui-disabled) {
      border: 1px solid ${alpha(AI_COLORS.main, 0.48)};

      :hover {
        background: ${alpha(AI_COLORS.main, 0.16)};
        border: 1px solid ${alpha(AI_COLORS.main, 0.48)};
        color: ${AI_COLORS.main};
      }
    }
  `}
`;
